module.exports = __webpack_public_path__ + "img/slide-23.5f867d50.jpeg";